import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation('layout');
  return (
    <div className="notfound">
      <div className="notfound__code">404</div>
      <p>{t('notFound.message')}</p>
      <a className="notfound__link" href="/">
        {t('notFound.backToBoard')}
      </a>
    </div>
  );
}

export default NotFoundPage;
